<div class="athlete-dialog__section">
  <h2 mat-dialog-title>{{ data?.id ? "Edit Athletes" : "Add Athletes" }}</h2>
  <mat-dialog-content>
    <div class="email-form" *ngIf="!isShowDetail" [formGroup]="emailForm">
      <mat-form-field class="full-width" appearance="outline" floatLabel="always">
        <mat-label>Email</mat-label>
        <input type="text" matInput placeholder="" formControlName="email" />
        <mat-error *ngIf="emailForm.controls?.email?.errors && emailForm.controls?.email?.touched">
          <div [innerHTML]="emailForm.controls.email.errors | errorFormFormat: { fieldName: 'Email' }"></div>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="dialog-add-detail-form"  *ngIf="isShowDetail" [formGroup]="detailForm">
      <div class="color-background-darker u-border-radius u-padding-16 u-margin-bottom-20">
        <div class="u-font-weight-400 u-font-size-16 u-margin-bottom-20">Personal</div>

        <div class="full-width photo">
          <img class="width-100-percent" *ngIf="detailForm?.value?.photo" [src]="detailForm.value?.photo" alt="athlete logo"/>
          <div class="o-flex">
            <span class="u-font-weight-700 u-font-size-xsmall file-color-text u-margin-right-5">File</span>
            <button style="display:block; height:20px;" class="u-font-weight-400 u-font-size-xsmall" onclick="document.getElementById('avatar').click()">Upload an image of the athlete</button>
            <input style="display:none" type="file" id="avatar" name="avatar" accept="image/png, image/jpeg" (change)="changeImage($event)"/>
            <span class="u-font-weight-700 u-font-size-xsmall file-color-text u-margin-left-5" *ngIf="!imgFile">No file choosen (jpg, png, max 100kb)</span>
            <span class="u-font-weight-700 u-font-size-xsmall file-color-text u-margin-left-5" *ngIf="imgFile">{{imgFile.name}}</span>
          </div>
        </div>

        <div class="o-flex o-flex--justify-space-between u-margin-top-20">
          <mat-form-field class="width-49-percent"appearance="outline" floatLabel="always">
            <mat-label>First Name</mat-label>
            <input type="text" matInput placeholder="" formControlName="first_name"/>
            <mat-error *ngIf="detailForm?.controls?.first_name?.errors && detailForm?.controls?.first_name?.touched">
              <div [innerHTML]="detailForm.controls.first_name.errors | errorFormFormat: { fieldName: 'First Name' }"></div>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>Last Name</mat-label>
            <input type="text" matInput placeholder="" formControlName="last_name"/>
            <mat-error *ngIf="detailForm?.controls?.last_name?.errors && detailForm?.controls?.last_name?.touched">
              <div [innerHTML]="detailForm.controls.last_name.errors | errorFormFormat: { fieldName: 'Last Name' }"></div>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="o-flex o-flex--justify-space-between">
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>Email</mat-label>
            <input type="text" matInput placeholder="" formControlName="email"/>
            <mat-error *ngIf="detailForm?.controls?.email?.errors && detailForm?.controls?.email?.touched">
              <div [innerHTML]="detailForm.controls.email.errors | errorFormFormat: { fieldName: 'Email 1' }"></div>
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" class="width-49-percent">
            <mat-label>Gender</mat-label>
            <mat-select formControlName="gender">
              <mat-option *ngFor="let item of genderOptions" [value]="item?.value">{{ item?.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="detailForm?.controls?.gender?.errors &&detailForm?.controls?.gender?.touched">
              <div [innerHTML]="detailForm.controls.gender.errors | errorFormFormat: { fieldName: 'Gender' }"></div>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="o-flex o-flex--justify-space-between">
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>Default Weight</mat-label>
            <span matSuffix>kg</span>
            <input type="number" matInput placeholder="" formControlName="default_weight"/>
            <mat-error *ngIf="detailForm?.controls?.default_weight?.errors && detailForm?.controls?.default_weight?.touched">
              <div [innerHTML]="detailForm.controls.default_weight.errors | errorFormFormat: { fieldName: 'Default Weight' }"></div>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>Default Height</mat-label>
            <span matSuffix>cm</span>
            <input type="number" matInput placeholder="" formControlName="default_height"/>
            <mat-error *ngIf="detailForm?.controls?.default_height?.errors && detailForm?.controls?.default_height?.touched">
              <div [innerHTML]="detailForm.controls.default_height.errors | errorFormFormat: { fieldName: 'Default Height' }"></div>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="o-flex o-flex--justify-space-between">
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>Date Of Birth</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dob" (click)="picker.open()"/>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="detailForm?.controls?.dob?.errors &&detailForm?.controls?.dob?.touched">
              <div [innerHTML]="detailForm.controls.dob.errors | errorFormFormat: { fieldName: 'Date of birth' }"></div>
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" class="width-49-percent">
            <mat-label>Athlete Category</mat-label>
            <mat-select data-component="add-athlete-category" formControlName="training_level">
              <mat-option *ngFor="let item of trainingLevelOptions" [value]="item?.id">{{ item?.value }}</mat-option>
            </mat-select>
            <mat-error *ngIf="detailForm?.controls?.training_level?.errors && detailForm?.controls?.training_level?.touched">
              <div [innerHTML]="detailForm.controls.training_level.errors | errorFormFormat: { fieldName: 'Athlete Category' }"></div>
            </mat-error>
          </mat-form-field>
        </div>
        <app-coach-chips
          class="width-100-percent"
          data-component="add-athlete-coach"
          [label]="'Users who can see the data of this athlete'"
          [form]="detailForm.get('coaches')"
          [options]="coachesOptions"
          [displayField]="'username'"
          (optionChange)="onSelectCoach($event)"
        ></app-coach-chips>
        <mat-slide-toggle *ngIf="!isAthleteDeactivation" formControlName="is_active">Active</mat-slide-toggle>
      </div>

      <mat-expansion-panel *ngIf="showEquipment" class="color-background-darker u-margin-bottom-20">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Default Equipment used by the athlete
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="o-flex o-flex--justify-center o-flex--wrap">
          <app-test-equipment
            class="u-margin-right-10 u-margin-bottom-10"
            *ngFor="let item of testEquipmentTileList"
            (onChange)="onChangeEquipment($event)"
            [equipmentDeviceList]="originalDeviceList"
            [config]="item"
            [context]="testCreationType"
            [isExpanded]="true"
          ></app-test-equipment>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel class="color-background-darker u-margin-bottom-20">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Optional: Home address of athlete
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="o-flex o-flex--justify-space-between u-margin-top-20">
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>Street</mat-label>
            <input type="text" matInput placeholder="" formControlName="address_street_name"/>
            <mat-error *ngIf="detailForm?.controls?.address_street_name?.errors && detailForm?.controls?.address_street_name?.touched">
              <div [innerHTML]="detailForm.controls.address_street_name.errors | errorFormFormat: { fieldName: 'Street' }"></div>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>Street No</mat-label>
            <input type="text" matInput placeholder="" formControlName="address_street_number"/>
            <mat-error *ngIf="detailForm?.controls?.address_street_number?.errors && detailForm?.controls?.address_street_number?.touched">
              <div [innerHTML]="detailForm.controls.address_street_number.errors | errorFormFormat: { fieldName: 'Street Number' }"></div>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="o-flex o-flex--justify-space-between u-margin-top-20">
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>Zip</mat-label>
            <input type="number" matInput placeholder="" formControlName="address_zip"/>
            <mat-error *ngIf="detailForm?.controls?.address_zip?.errors && detailForm?.controls?.address_zip?.touched">
              <div [innerHTML]="detailForm.controls.address_zip.errors | errorFormFormat: { fieldName: 'Zip' }"></div>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>City</mat-label>
            <input type="text" matInput placeholder="" formControlName="address_city"/>
            <mat-error *ngIf="detailForm?.controls?.address_city?.errors && detailForm?.controls?.address_city?.touched">
              <div [innerHTML]="detailForm.controls.address_city.errors | errorFormFormat: { fieldName: 'City' }"></div>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="o-flex o-flex--justify-space-between u-margin-top-20">
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>State</mat-label>
            <input type="text" matInput placeholder="" formControlName="address_state"/>
            <mat-error *ngIf="detailForm?.controls?.address_state?.errors && detailForm?.controls?.address_state?.touched">
              <div [innerHTML]="detailForm.controls.address_state.errors | errorFormFormat: { fieldName: 'State' }"></div>
            </mat-error>
          </mat-form-field>
          <div class="width-49-percent">
            <app-autocomplate [options]="countriesOptions" [form]="this.detailForm.get('address_country')" [label]="'Country'"></app-autocomplate>
          </div>
        </div>
        <div class="o-flex o-flex--justify-space-between u-margin-top-20">
          <mat-form-field class="width-100-percent" appearance="outline" floatLabel="always">
            <mat-label>Phone 1</mat-label>
            <input type="text" matInput placeholder="" formControlName="phone"/>
            <mat-error *ngIf="detailForm?.controls?.phone?.errors && detailForm?.controls?.phone?.touched">
              <div [innerHTML]="detailForm.controls.phone.errors | errorFormFormat: { fieldName: 'Phone 1' }"></div>
            </mat-error>
          </mat-form-field>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel class="color-background-darker u-margin-bottom-20">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Optional: Additional info about athlete
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="o-flex o-flex--justify-space-between u-margin-top-20">
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>Website</mat-label>
            <input type="text" matInput placeholder="" formControlName="website"/>
            <mat-error *ngIf="detailForm?.controls?.website?.errors && detailForm?.controls?.website?.touched">
              <div [innerHTML]="detailForm.controls.website.errors | errorFormFormat: { fieldName: 'Website' }"></div>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>Facebook</mat-label>
            <input type="text" matInput placeholder="" formControlName="facebook"/>
            <mat-error *ngIf="detailForm?.controls?.facebook?.errors && detailForm?.controls?.facebook?.touched">
              <div [innerHTML]="detailForm.controls.facebook.errors | errorFormFormat: { fieldName: 'Facebook' }"></div>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="o-flex o-flex--justify-space-between u-margin-top-20">
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>X (Twitter)</mat-label>
            <input type="text" matInput placeholder="" formControlName="twitter"/>
            <mat-error *ngIf="detailForm?.controls?.twitter?.errors && detailForm?.controls?.twitter?.touched">
              <div [innerHTML]="detailForm.controls.twitter.errors | errorFormFormat: { fieldName: 'Twitter' }"></div>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="width-49-percent" appearance="outline" floatLabel="always">
            <mat-label>Instagram</mat-label>
            <input type="text" matInput placeholder="" formControlName="instagram"/>
            <mat-error *ngIf="detailForm?.controls?.instagram?.errors && detailForm?.controls?.instagram?.touched">
              <div [innerHTML]="detailForm.controls.instagram.errors| errorFormFormat: { fieldName: 'Instagram' }"></div>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="o-flex o-flex--justify-space-between u-margin-top-20">
          <app-chips
            class="width-100-percent"
            [label]="'Tags'"
            [form]="detailForm.get('tags')"
            [options]="tagOptions"
            (optionChange)="onSelectTag($event)"
          ></app-chips>
        </div>
      </mat-expansion-panel>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="o-flex o-flex--justify-space-between width-100-percent">
      <button id="cancelButton" class="width-49-percent" mat-raised-button (click)="close()" type="button">Cancel</button>
      <button id="saveButton" class="width-49-percent" *ngIf="isShowDetail" mat-raised-button color="primary" (click)="save()">Save</button>
      <button id="nextButton" class="width-49-percent" *ngIf="!isShowDetail" mat-raised-button color="primary" (click)="next()">Next</button>
    </div>
  </mat-dialog-actions>
</div>
